var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import OtpInput from "react-otp-input";
import { useHistory } from "react-router-dom";
import logo from "../assets/logo.png";
import { useAppDispatch } from "../hooks/hooks";
import { userConstants } from "../store/actions/types";
import { getApplicationRoles } from "../utils/getApplicationRoles";
import { makeSessionRequest } from "../utils/makeSessionRequest";
export default function Login() {
    const [email, setEmail] = useState("");
    const [response, setResponse] = useState();
    const [otp, setOtp] = useState("");
    const [generatingOtp, setGeneratingOtp] = useState(false);
    const [verifyingOtp, setVerifyingOtp] = useState(false);
    const history = useHistory();
    const dispatch = useAppDispatch();
    const sendOtp = (e) => {
        e.preventDefault();
        if (!email.match(/^([a-zA-Z0-9_\-+.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/)) {
            alert("Invalid email");
            return;
        }
        setGeneratingOtp(true);
        axios
            .post(process.env.REACT_APP_HELLOAR_API + "auth/send_otp", {
            email: email,
            app_source: "web",
        })
            .then((res) => {
            setResponse({ requestId: res.data.request_id });
            setGeneratingOtp(false);
        })
            .catch((err) => {
            toast.error("User not found");
            setGeneratingOtp(false);
        });
    };
    const verifyOtp = (e) => {
        e.preventDefault();
        if (!(response === null || response === void 0 ? void 0 : response.requestId)) {
            return;
        }
        setVerifyingOtp(true);
        axios
            .post(process.env.REACT_APP_HELLOAR_API + "auth/verify_otp", {
            request_id: response.requestId,
            otp: parseInt(otp),
        })
            .then((res) => __awaiter(this, void 0, void 0, function* () {
            const userId = res.data.account_id;
            const roleData = yield getApplicationRoles({
                userId,
            });
            const requiredRoleData = roleData.data._items.filter((item) => item.application === process.env.REACT_APP_APPLICATION_ID);
            if (requiredRoleData.length > 0) {
                localStorage.setItem("userTags", JSON.stringify(requiredRoleData[0].tags));
                localStorage.setItem("user", JSON.stringify(Object.assign(Object.assign({}, res.data), { role: requiredRoleData[0].role, viewer: requiredRoleData[0].viewer })));
                dispatch({
                    type: userConstants.SET_USER,
                    payload: Object.assign(Object.assign({}, res.data), { token: res.data.access_token, email }),
                });
                history.push("/dashboard");
                setVerifyingOtp(false);
                setResponse(undefined);
                setOtp("");
                makeSessionRequest("user_logged_in");
            }
            else {
                setVerifyingOtp(false);
                setResponse(undefined);
                setOtp("");
                window.alert("You're not allowed to use this app.");
            }
        }))
            .catch((err) => {
            console.error(err);
            toast.error("Invalid OTP");
            setVerifyingOtp(false);
        });
    };
    return (_jsx("div", Object.assign({ className: "sm:px-16 px-4 h-screen flex items-center flex-col " }, { children: _jsx("div", Object.assign({ className: "flex flex-grow flex-wrap flex-col w-full justify-center items-center" }, { children: (response === null || response === void 0 ? void 0 : response.requestId) ? (_jsxs("form", Object.assign({ onSubmit: verifyOtp, style: { height: "max-content" }, className: " w-full sm:w-1/2 lg:w-1/3 sm:p-8 md:p-16 md:pt-0 p-4 flex flex-col shadow-lg items-center justify-between" }, { children: [_jsx("div", Object.assign({ className: "flex justify-center py-4 mb-6 flex-grow-0" }, { children: _jsx("img", { src: logo, className: " w-62 h-auto", alt: "" }) })), _jsxs("h3", Object.assign({ className: "text-2xl font-bold mb-4 text-center" }, { children: ["OTP sent to ", _jsx("br", {}), " ", email] })), _jsx("h4", { children: "Can you please verify it?" }), _jsx(OtpInput, { inputStyle: "border font-bold text-2xl md:text-3xl lg:text-4xl focus:outline-none otp-input", containerStyle: "my-4", numInputs: 4, renderSeparator: _jsx("span", Object.assign({ className: "mx-1" }, { children: "-" })), renderInput: (props) => _jsx("input", Object.assign({}, props)), value: otp, onChange: (otp) => setOtp(otp) }), _jsx("h3", Object.assign({ onClick: sendOtp, className: " cursor-pointer w-max ml-auto mr-auto mb-8 mt-4 hover:text-customRed underline font-bold text-lg" }, { children: generatingOtp ? "Generating OTP..." : "Resend OTP" })), _jsx("button", Object.assign({ onClick: verifyOtp, style: { backgroundColor: verifyingOtp ? "#a9301c" : "#57ca85" }, className: `${verifyingOtp ? "text-gray-300" : "text-white"} px-4 py-4   font-bold text-2xl w-full` }, { children: verifyingOtp ? "Verifying OTP..." : "Confirm" })), _jsx("h3", Object.assign({ onClick: () => setResponse(undefined), className: " cursor-pointer w-max ml-auto mr-auto mb-0 mt-8 hover:text-customRed underline font-bold text-lg" }, { children: "Use different email address" }))] }))) : (_jsxs("form", Object.assign({ onSubmit: sendOtp, style: { height: "max-content" }, className: " w-full  sm:w-1/2 xl:w-1/3 sm:p-8 md:p-16 md:pt-0 p-4 mt-4 flex flex-col shadow-lg justify-between" }, { children: [_jsx("div", Object.assign({ className: "flex justify-center py-4 mb-6 flex-grow-0" }, { children: _jsx("img", { src: logo, className: " w-62 h-auto", alt: "" }) })), _jsx("h3", Object.assign({ className: "text-xl mb-4" }, { children: "Email Address" })), _jsx("input", { className: "border mb-4 text-xl px-4 py-2 focus:outline-none", type: "email", value: email, onChange: (e) => setEmail(e.target.value) }), _jsx("button", Object.assign({ onClick: sendOtp, disabled: generatingOtp, style: { backgroundColor: generatingOtp ? "#a9301c" : "#57ca85" }, className: `${generatingOtp ? "text-gray-300" : "text-white"} px-4 py-2 mt-8 font-bold text-2xl ` }, { children: generatingOtp ? "Generating OTP..." : "Next" }))] }))) })) })));
}
